import { BodyLinkV3, TypographyV3 } from '@jouzen/ecom-components';
import type { JSX } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

interface UpgradeWarrantyBenefitsReturn {
  name: string;
  ListItem: JSX.Element;
}

const upgradeWarrantyBenefits = (
  t: (str: MessageKey) => string,
): UpgradeWarrantyBenefitsReturn[] => [
  {
    name: 'damage_and_battery',
    ListItem: (
      <TypographyV3 className="text-sm">{t('damage_and_battery')}</TypographyV3>
    ),
  },
  {
    name: 'mechanical_and_electrical',
    ListItem: (
      <TypographyV3 className="text-sm">
        {t('mechanical_and_electrical')}
      </TypographyV3>
    ),
  },
  {
    name: 'simple_online_claims',
    ListItem: (
      <TypographyV3 className="text-sm">
        {t('simple_online_claims')}
      </TypographyV3>
    ),
  },
  {
    name: 'zero_deductible',
    ListItem: (
      <TypographyV3 className="text-sm">{t('zero_deductible')}</TypographyV3>
    ),
  },
  {
    name: 'free_shipping_for_replacement',
    ListItem: (
      <TypographyV3 className="text-sm">
        {t('free_shipping_for_replacement')}
      </TypographyV3>
    ),
  },
  {
    name: 'details_and_faq',
    ListItem: (
      <BodyLinkV3
        className="text-sm"
        href="https://customers.extend.com/en-US/plan_details/A0-oura-3y?storeId=4a821e29-c414-45d5-b663-15c4ecf082b6"
        target="_blank"
      >
        {t('details_and_faq')}
      </BodyLinkV3>
    ),
  },
];

export default upgradeWarrantyBenefits;
